/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The signature is created entirely in your browser and the PNG is generated on your device. Nothing is sent to a server.`)
};

const es_sig_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La firma se crea completamente en tu navegador y el PNG se genera en tu dispositivo. Nada se envía a un servidor.`)
};

const de_sig_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Die Signatur wird vollständig in Ihrem Browser erstellt und die PNG wird auf Ihrem Gerät generiert. Nichts wird an einen Server gesendet.`)
};

const nl_sig_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. De handtekening wordt volledig in uw browser gemaakt en de PNG wordt op uw apparaat gegenereerd. Niets wordt naar een server gestuurd.`)
};

const fr_sig_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. La signature est créée entièrement dans votre navigateur et le PNG est généré sur votre appareil. Rien n'est envoyé à un serveur.`)
};

const it_sig_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La firma viene creata interamente nel tuo browser e il PNG viene generato sul tuo dispositivo. Nulla viene inviato a un server.`)
};

const pt_br2_sig_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A assinatura é criada inteiramente no seu navegador e o PNG é gerado no seu dispositivo. Nada é enviado para um servidor.`)
};

const pt_sig_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A assinatura é criada inteiramente no seu navegador e o PNG é gerado no seu dispositivo. Nada é enviado para um servidor.`)
};

const ja_sig_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。署名はブラウザで完全に作成され、PNGはデバイス上で生成されます。何もサーバーに送信されません。`)
};

const zh_sig_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。签名完全在您的浏览器中创建，PNG 在您的设备上生成。任何内容都不会发送到服务器。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_hub_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_hub_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_hub_faq1_a", locale)
	if (locale === "en") return en_sig_hub_faq1_a(inputs)
	if (locale === "es") return es_sig_hub_faq1_a(inputs)
	if (locale === "de") return de_sig_hub_faq1_a(inputs)
	if (locale === "nl") return nl_sig_hub_faq1_a(inputs)
	if (locale === "fr") return fr_sig_hub_faq1_a(inputs)
	if (locale === "it") return it_sig_hub_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_sig_hub_faq1_a(inputs)
	if (locale === "pt") return pt_sig_hub_faq1_a(inputs)
	if (locale === "ja") return ja_sig_hub_faq1_a(inputs)
	return zh_sig_hub_faq1_a(inputs)
};